import styled from "styled-components";

import Text from "components/atoms/text/Text";

export const PanelCard = styled.div`
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 40px;
`;

export const IntroDescription = styled(Text)`
    font-size: 1.2rem;
    color: var(--color-Grey1);
`;

export const InitialFieldCard = styled.div`
    border: 1px solid
        ${(props) =>
            props.$collapsible
                ? props.$expanded
                    ? "var(--color-Key)"
                    : "var(--color-Outline)"
                : "var(--color-Outline)"};
    border-radius: 10px;
    background: ${(props) => (props.$collapsible ? "var(--color-White)" : "var(--color-Base1)")};
    padding: ${(props) => (props.$collapsible ? "0" : "12px")};
    transition:
        border-color 0.2s ease,
        box-shadow 0.2s ease;
    box-shadow: ${(props) => (props.$collapsible && props.$expanded ? "0 2px 8px rgba(15, 23, 42, 0.06)" : "none")};
`;

export const InitialFieldPrompt = styled(Text)`
    margin-bottom: 4px;
    font-size: 1.4rem;
    font-weight: 500;
    color: var(--color-SubBlack);
`;

export const InitialFieldHeader = styled.button`
    width: 100%;
    border: 0;
    background: transparent;
    padding: 10px 12px;
    min-height: 52px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    text-align: left;
    cursor: pointer;

    ${InitialFieldPrompt} {
        margin-bottom: 0;
    }
`;

export const InitialFieldSummary = styled.div`
    margin-top: 3px;
    font-size: 1.2rem;
    color: var(--color-Grey1);
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const InitialFieldChevron = styled.span`
    font-size: 1.3rem;
    color: var(--color-Grey1);
    transform: ${(props) => (props.$expanded ? "rotate(180deg)" : "rotate(0deg)")};
    transition: transform 0.2s ease;
`;

export const InitialFieldBody = styled.div`
    border-top: 1px solid var(--color-Outline);
    padding: 8px 12px 10px;
`;

export const QuestionOptionRow = styled.label`
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 4px 0;
    cursor: pointer;
`;

export const OptionTextWrap = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const OptionLabel = styled.span`
    font-size: 1.3rem;
    color: var(--color-SubBlack);
`;

export const OptionDescription = styled.span`
    font-size: 1.2rem;
    color: var(--color-Grey1);
`;

export const InputWrap = styled.div`
    display: flex;
    gap: 8px;
`;

export const QueryInput = styled.input`
    flex: 1;
    padding: 10px;
    border: 1px solid var(--color-Key);
    border-radius: 4px;
    font-size: 1.4rem;
    color: var(--color-SubBlack);
    outline: none;
    height: 44px;

    &::placeholder {
        color: var(--color-Grey2);
    }
`;

export const InlineInputRow = styled.div`
    display: flex;
    gap: 8px;
    margin-top: 8px;
`;

export const InlineInput = styled.input`
    flex: 1;
    height: 36px;
    border: 1px solid var(--color-Outline);
    border-radius: 6px;
    padding: 0 10px;
    outline: none;
    font-size: 1.3rem;
`;

export const PlanBox = styled.div`
    border-radius: 4px;
    background: var(--color-Base1);
    padding: 10px;
    white-space: pre-wrap;
    line-height: 1.5;

    font-size: 1.4rem;
    color: var(--color-SubBlack);
`;

export const StatusRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
`;

export const PhaseBadge = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 1.2rem;
    font-weight: 600;
    background: ${(props) => (props.kind === "error" ? "#fee2e2" : props.kind === "done" ? "#dcfce7" : "#fef3c7")};
    color: ${(props) => (props.kind === "error" ? "#991b1b" : props.kind === "done" ? "#166534" : "#92400e")};
`;

export const ReportBox = styled.div`
    border-radius: 4px;
    background: var(--color-Base1);
    padding: 10px;
    white-space: pre-wrap;
    line-height: 1.5;

    font-size: 1.4rem;
    color: var(--color-SubBlack);
`;

export const HtmlReportBox = styled.div`
    border-radius: 4px;
    background: var(--color-Base1);
    padding: 10px;
    white-space: pre-wrap;
    line-height: 1.5;

    font-size: 1.4rem;
    color: var(--color-SubBlack);
`;

export const SourceList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SourceItem = styled.a`
    display: block;
    text-decoration: none;
    padding: 10px 12px;
    border: 1px solid #f3d19a;
    border-radius: 8px;
    font-size: 1.4rem;
    color: var(--color-SubBlack);
    background: var(--color-White);
`;

export const SourceMetaRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
`;

export const SourceBadge = styled.span`
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 2px 8px;
    font-size: 1.1rem;
    font-weight: 600;
    background: #fff7ed;
    color: #9a3412;
`;

export const LogItem = styled.div`
    border-radius: 8px;
    background: var(--color-White);
    border: 1px solid #e5e7eb;
    padding: 10px;
`;

export const LogStage = styled.div`
    font-size: 1.1rem;
    font-weight: 700;
    color: #0369a1;
    margin-bottom: 4px;
`;

export const LogMessage = styled.div`
    font-size: 1.2rem;
    color: var(--color-SubBlack);
`;

export const LogMeta = styled.div`
    margin-top: 6px;
    font-size: 1.1rem;
    color: var(--color-Grey1);
    white-space: pre-wrap;
`;

export const LogAccordionCard = styled.div`
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    background: #f8fafc;
    overflow: hidden;
`;

export const LogAccordionHeader = styled.button`
    width: 100%;
    border: 0;
    background: transparent;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    text-align: left;
    cursor: pointer;
`;

export const LogAccordionTitle = styled.div`
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--color-SubBlack);
`;

export const LogAccordionSummary = styled.div`
    margin-top: 3px;
    font-size: 1.2rem;
    color: var(--color-Grey1);
    line-height: 1.4;
`;

export const LogAccordionChevron = styled.span`
    font-size: 1.3rem;
    color: var(--color-Grey1);
    transform: ${(props) => (props.expanded ? "rotate(180deg)" : "rotate(0deg)")};
    transition: transform 0.2s ease;
`;

export const LogAccordionBody = styled.div`
    border-top: 1px solid #e2e8f0;
    padding: 10px 12px 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ErrorText = styled(Text)`
    font-size: 1.2rem;
    color: #dc2626;
`;
